import React, { forwardRef, useRef, useImperativeHandle } from "react";
import styled from "styled-components";
import NextBtn from './next';
import { jumpTo } from '@/utils';

const Page2 = ({ data, onNext }, ref) => {

  const containerRef = useRef();

  useImperativeHandle(ref, () => {
    return {
      shareContainer() {
        return containerRef.current
      }
    }
  });

  const handleLinkToArticle = () => {
    if (data.mostActivePostType === 5) {
      jumpTo(`${process.env.REACT_APP_WOGOO_URL}/essay/#/community?momentsId=${data.mostActivePostId}`)
    } else {
      jumpTo(`${process.env.REACT_APP_WOGOO_URL}/essay/#/?articleId=${data.mostActivePostId}`);
    }
  }

  return (
    <Container className="page page2" ref={containerRef}>
      {!!data.postsCount && (
        <div className="data-wrap">
          <div className="user-data">2025这一年</div>
          <div className="user-data">
            你创作了
            <span className="light-data">{data.postsCount}</span>
            篇内容
          </div>
          <div className="user-data">
            超越了<span className="light-data">{data.postsX}%</span>的风云用户
          </div>
          <div className="user-data" onClick={handleLinkToArticle}>
            <span className="light-data">“{data.mostActivePostTitle}”</span>
          </div>
          <div className="user-data">这条内容获得了最高的互动量</div>
          <div className="user-data">你持续的创作，是社区最珍贵的财富！</div>
          <img className="award-tip" src="https://file.wogoo.com/image/activity/active_205/award-tip@2x.png" alt="" />
        </div>
      )}

      {!data.postsCount && (
        <div className="data-wrap">
          <div className="user-data">
            2025年4月7日
          </div>
          <div className="user-data">
            大盘千股跌停，跌至低点<span className="light-data">3040</span>点
          </div>
          <div className="user-data">随后开启浩浩荡荡的主升浪</div>
        </div>
      )}

      <div className="data-bg">
        <img
          className="logo-img"
          src="https://file.wogoo.com/image/activity/active_205/page2-bg@2x.png"
          alt=""
        />
      </div>
      <div className="data-bg">
        <img className="logo-img" src="https://file.wogoo.com/image/activity/active_205/bottom-arrow@2x.png" alt=""/>
      </div>
      <div className="page-logo">
        <img className="logo-img" src="https://file.wogoo.com/image/activity/active_205/page-logo@2x.png" alt=""/>
      </div>
      <NextBtn onClick={onNext} />
    </Container>
  );
};

const Container = styled.div``;

export default React.memo(forwardRef(Page2));



// WEBPACK FOOTER //
// ./src/views/activity_205/page2.js